import React, { useRef } from 'react'
import { useSelector } from 'react-redux'

import MultiSelectCalendar, { MONTH_VIEW_MINIMUM_WIDTH } from './MultiSelectCalendar'
import useSessionSaver from '../../hooks/useSessionSaver'
import { selectLeagueForDatePicking } from '../../reducers/leagues_dates'

import useContainerSize from 'Shared/hooks/useContainerSize'

const LeaguesDatesPicker = () => {
  const calendarContainerRef = useRef(null)
  const { width: calendarContainerWidth } = useContainerSize(calendarContainerRef)

  const displayedMonths = Math.max(1, Math.floor(calendarContainerWidth / MONTH_VIEW_MINIMUM_WIDTH))

  const { addDateToMassDates, removeDateFromMassDates, setMassDates, sessionData } = useSessionSaver()
  const leagueForDatePicking = useSelector(selectLeagueForDatePicking)

  const selectedDates = sessionData?.leagues?.[leagueForDatePicking?.id]?.mass_dates || []
  const startDate = selectedDates.length > 0
    ? selectedDates.reduce((earliest, date) => date < earliest ? date : earliest)
    : undefined

  return (
    <div ref={calendarContainerRef} className={'cls-ld-calendar-view'}>
      <span className={'cls-ld-calendar-view__header'}>
        <span className={'cls-ld-calendar-view__title'}>
          {window.I18n.t('clone_leagues_sessions.leagues_dates.select_dates')}
        </span>
        {leagueForDatePicking && <span className={'cls-ld-calendar-view__count'}>
          {leagueForDatePicking?.mass_dates?.length}/{leagueForDatePicking?.rounds?.length} {window.I18n.t('clone_leagues_sessions.general.selected')}
        </span>}
      </span>
      {leagueForDatePicking ?
        (<>
          <span className={'cls-ld-calendar-view__hint'}>
            {window.I18n.t('clone_leagues_sessions.leagues_dates.calendar_hint')}
          </span>
          <div className="cls-calendar-wrapper">
            <MultiSelectCalendar
              key={leagueForDatePicking?.id}
              displayedMonths={displayedMonths}
              selectedDates={selectedDates}
              startDate={startDate}
              onDateAdd={(dateKey) => addDateToMassDates(leagueForDatePicking?.id, dateKey)}
              onDateRemove={(dateKey) => removeDateFromMassDates(leagueForDatePicking?.id, dateKey)}
              onDatesClear={() => setMassDates(leagueForDatePicking?.id, [])}
            />
          </div>
        </>) :
        <div className={'cls-ld-calendar-view__no_league'}>
          {window.I18n.t('clone_leagues_sessions.leagues_dates.no_league_selected')}
        </div>
      }
    </div>

  )
}

export default LeaguesDatesPicker
